__turbopack_context__.v({
  "isDisabled": "tagsInput-module-scss-module__Qre7Da__isDisabled",
  "tagsInput": "tagsInput-module-scss-module__Qre7Da__tagsInput",
  "tagsInputWrapper": "tagsInput-module-scss-module__Qre7Da__tagsInputWrapper",
});
